// src/components/UserMenu.jsx
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const avatarStyle = {
  width: 28,
  height: 28,
  borderRadius: '50%',
  objectFit: 'cover',
  background: '#e9edf5',
};

export default function UserMenu({ user = {}, onLogout }) {
  const [open, setOpen] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const ref = useRef(null);
  const initials = (user.firstName?.[0] || '') + (user.lastName?.[0] || '');

  // fermer au clic extérieur / échappe
  useEffect(() => {
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onEsc = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('click', onDocClick);
    document.addEventListener('keydown', onEsc);
    return () => {
      document.removeEventListener('click', onDocClick);
      document.removeEventListener('keydown', onEsc);
    };
  }, []);

  return (
    <li className="h4 mx-2 my-auto position-relative" ref={ref}>
      <button
        type="button"
        className="btn btn-outline-primary border-0 d-inline-flex align-items-center"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="menu"
        aria-expanded={open}
        title="Mon compte"
      >
        {user.avatarUrl ? (
          <img src={user.avatarUrl} alt="" style={{ ...avatarStyle, marginRight: 8 }} />
        ) : (
          <div
            style={{
              ...avatarStyle,
              marginRight: 8,
              display: 'grid',
              placeItems: 'center',
              fontSize: 12,
              color: '#213b8f',
              fontWeight: 700,
            }}
          >
            {initials || '👤'}
          </div>
        )}
        <span style={{ fontSize: 16 }}>
          {user.firstName ? `Bonjour, ${user.firstName}` : 'Mon compte'}
        </span>
        <span className="ml-2" aria-hidden>
          ▾
        </span>
      </button>

      {open && (
        <ul
          className="dropdown-menu show p-2 rounded shadow-sm"
          style={{ right: 0, left: 'auto', minWidth: 220 }}
          role="menu"
        >
          <li role="none">
            <Link
              className="dropdown-item py-2"
              role="menuitem"
              to="/b2b/mon-profil"
              onClick={() => setOpen(false)}
            >
              Mon profil
            </Link>
          </li>
          <li role="none">
            <Link
              className="dropdown-item py-2"
              role="menuitem"
              to=""
              onClick={() => setOpen(false)}
            >
              Paramètres
            </Link>
          </li>
          <li role="none">
            <div className="dropdown-divider" />
          </li>
          <li role="none">
            <button
              className="dropdown-item text-danger py-2 d-flex align-items-center gap-2"
              role="menuitem"
              disabled={isLoggingOut}
              onClick={() => {
                setOpen(false);
                onLogout?.();
              }}
            >
              {isLoggingOut ? (
                <>
                  <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                  Déconnexion...
                </>
              ) : (
                'Déconnexion'
              )}
            </button>
          </li>
        </ul>
      )}
    </li>
  );
}
